import { render } from "./GameWindow.vue?vue&type=template&id=529ce07e&scoped=true"
import script from "./GameWindow.vue?vue&type=script&lang=js"
export * from "./GameWindow.vue?vue&type=script&lang=js"

import "./GameWindow.vue?vue&type=style&index=0&id=529ce07e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529ce07e"]])

export default __exports__